/* tabs
   ========================================================================== */
export const TAB_SHOW_EVENT = 'tab-show';
export default function addTabs() {
    const tabPanels = document.querySelectorAll('[data-component="tabs"]');
    tabPanels.forEach((tabPanel) => {
        const tabList = tabPanel.querySelector('.c-tabs__header');
        const tabs = Array.from(tabPanel.querySelectorAll('[role=tab]'));
        const panels = Array.from(tabPanel.querySelectorAll('[role=tabpanel]'));
        const firstTab = tabs[0];
        const lastTab = tabs[tabs.length - 1];
        const show = (tab, panel) => {
            tab.setAttribute('aria-selected', 'true');
            tab.setAttribute('tabindex', '0');
            panel.setAttribute('aria-hidden', 'false');
        };
        const hide = (tab, panel) => {
            tab.setAttribute('aria-selected', 'false');
            tab.setAttribute('tabindex', '-1');
            panel.setAttribute('aria-hidden', 'true');
        };
        const render = (currentTab, currentPanel) => {
            tabs.forEach((tab, index) => {
                if (tab !== currentTab) {
                    hide(tab, panels[index]);
                }
                else {
                    show(currentTab, currentPanel);
                }
            });
        };
        const handleKeydown = (event) => {
            const currentTab = event.currentTarget;
            const currentIndex = tabs.indexOf(currentTab);
            let targetTab;
            switch (event.key) {
                case 'ArrowLeft':
                case 'ArrowUp':
                    event.preventDefault();
                    targetTab = currentIndex > 0 ? tabs[currentIndex - 1] : lastTab;
                    break;
                case 'ArrowRight':
                case 'ArrowDown':
                    event.preventDefault();
                    targetTab = currentIndex < tabs.length - 1 ? tabs[currentIndex + 1] : firstTab;
                    break;
                case 'Home':
                    event.preventDefault();
                    targetTab = firstTab;
                    break;
                case 'End':
                    event.preventDefault();
                    targetTab = lastTab;
                    break;
                default:
                    return;
            }
            if (targetTab) {
                const targetPanel = panels[tabs.indexOf(targetTab)];
                render(targetTab, targetPanel);
                targetTab.focus();
                window.history.pushState({ tab: targetTab.id }, '');
                targetPanel.dispatchEvent(new CustomEvent(TAB_SHOW_EVENT, {
                    detail: { id: targetPanel.id }
                }));
            }
        };
        if (tabList) {
            tabList.setAttribute('role', 'tablist');
        }
        tabs.forEach((tab, index) => {
            tab.addEventListener('click', (event) => {
                const panel = panels[index];
                event.preventDefault();
                render(tab, panel);
                window.history.pushState({ tab: tab.id }, '');
                panel.dispatchEvent(new CustomEvent(TAB_SHOW_EVENT, {
                    detail: { id: panel.id }
                }));
            });
            tab.addEventListener('keydown', handleKeydown);
            if (window.history.state?.tab === tab.id) {
                render(tab, panels[index]);
            }
        });
        const initialTab = tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || firstTab;
        render(initialTab, panels[tabs.indexOf(initialTab)]);
    });
}
